import settings from '@/constants/constants';
import { Alert, AlertTitle, Link, Typography, ViewObserver } from '@montugroup/design-system';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

interface SasApprovalAlert {
  enabled: boolean;
}

export const SasApprovalAlert = (props: SasApprovalAlert) => {
  const { enabled } = props;

  if (!enabled) {
    return null;
  }

  return (
    <ViewObserver id="sas-approval-alert">
      <Alert
        severity="info"
        icon={<InfoOutlined />}
        sx={(theme) => ({
          width: '100%',
          marginTop: theme.spacing(4),
        })}
        data-testid="sasapprovalalert"
      >
        <AlertTitle>Special Access Scheme (SAS) approval in progress</AlertTitle>
        <Typography variant="inherit">
          Your doctor is awaiting SAS approval from the TGA to prescribe your medication. This may delay your order by
          5-7 business days.
        </Typography>
        <Typography variant="inherit">
          <Link href={settings.regulationsApprovalsUrl}>More details on SAS approval</Link>
        </Typography>
      </Alert>
    </ViewObserver>
  );
};
